import React from 'react';
import { Box, Container, Typography, Avatar, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const TestimonialSection: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      id="testimonial"
      sx={{
        py: 12,
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, #1565c0 100%)`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background pattern */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.05,
          backgroundImage: `radial-gradient(#fff 2px, transparent 2px)`,
          backgroundSize: '30px 30px',
          zIndex: 0,
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <FormatQuoteIcon
              sx={{
                fontSize: 80,
                color: 'rgba(255, 255, 255, 0.2)',
                transform: 'rotate(180deg)',
                mb: 4,
              }}
            />

            <Box sx={{ maxWidth: '800px' }}>
              <Typography
                variant="h4"
                component="blockquote"
                sx={{
                  fontWeight: 500,
                  color: '#fff',
                  fontStyle: 'italic',
                  mb: 4,
                  lineHeight: 1.5,
                  letterSpacing: '0.01em',
                }}
              >
                "После внедрения GameGuard AI удержание пользователей выросло на 32%, а количество жалоб на читеров сократилось на 87%. Внедрение заняло всего 10 минут — это оказалось самым простым и эффективным решением одной из наших главных проблем."
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Avatar
                  sx={{
                    width: 64,
                    height: 64,
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: theme.palette.primary.main,
                    fontSize: '1.5rem',
                    fontWeight: 700,
                    mb: 2,
                  }}
                >
                  ИС
                </Avatar>
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 600 }}>
                  Руководитель инди-студии
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.8)', mt: 0.5 }}>
                  Unity-разработчик с 8-летним опытом
                </Typography>
              </Box>
            </Box>
          </Box>
        </motion.div>

        <Box
          sx={{
            mt: 8,
            p: 4,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            borderRadius: 4,
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <Typography variant="h5" sx={{ color: '#fff', fontWeight: 600, mb: 1 }}>
              Проверенные результаты
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              Не позволяйте читерам портить впечатление от вашей игры и подрывать вашу бизнес-модель.
              GameGuard AI обеспечивает защиту уровня AAA-проектов по доступной цене для студий любого размера.
            </Typography>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialSection; 